import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InfiniteCanvasDto } from 'src/types/infinite-canvas-dto';

export interface InfiniteCanvasState {
  listInfiniteCanvases: Record<string, InfiniteCanvasDto[]>;
}

const initialState: InfiniteCanvasState = {
  listInfiniteCanvases: {},
};

type ListInfiniteAction = PayloadAction<{
  canvases: InfiniteCanvasDto[];
  teamId: string;
}>;

type DeleteInfiniteAction = PayloadAction<{
  teamId: string;
  id: string;
}>;

const reducers = {
  list(state: InfiniteCanvasState, action: ListInfiniteAction): void {
    state.listInfiniteCanvases[action.payload.teamId] = action.payload.canvases;
  },
  delete(state: InfiniteCanvasState, action: DeleteInfiniteAction): void {
    const teamId = action.payload.teamId;
    state.listInfiniteCanvases[teamId] = state.listInfiniteCanvases[teamId].filter(
      (canvas) => canvas.id !== action.payload.id,
    );
  },
};

export const slice = createSlice({
  name: 'InfiniteCanvas',
  initialState,
  reducers,
});

export const { reducer } = slice;
